// eslint-disable-next-line import/no-unresolved
import useSWR from 'swr'
import axios from 'axios'

export const useDetectBot = () => {
	const { data, error, mutate, isValidating } = useSWR(['/bot/check'], ([url]) =>
		axios({ method: 'GET', url }).then((res) => res.data)
	)

	return {
		isBot: data,
		error,
		mutate,
		loading: isValidating,
		called: data !== undefined,
	}
}
